import asServedSets from './as-served-sets';
import drinkwareSets from './drinkware-sets';
import guideImages from './guide-images';
import imageMaps from './image-maps';

export default {
  'as-served-sets': asServedSets,
  'drinkware-sets': drinkwareSets,
  'guide-images': guideImages,
  'image-maps': imageMaps,
};
